import React, { useEffect } from 'react';

import SimpleBar from 'simplebar-react';
import TableClients from '../table/table-clients';
import FilterComponent from '../../utils/searchBar';
import { useDispatch, useSelector } from 'react-redux';
import { getClientList as getClients, getTotalElements } from '../../../Redux/reducer/clients';
import { getClientList, clearClientsList } from '../../../Redux/actions/clientActions';
import i18next from 'i18next';
import contactProvider from "../../../../static/images/contactProvider.svg";

const filters = [
  { name: i18next.t('general.placeholders.name'), property: "name" },
  { name: i18next.t('general.placeholders.id'), property: "businessId" }
];

const FindInstitution = (props) => {
  const dispatch = useDispatch();
  const clientes = useSelector(state => getClients(state));
  const totalElements = useSelector(state => getTotalElements(state));
  const page = 0, sizePerPage = 5;  

  useEffect(() => {
    async function fetchClientList() {
      return await dispatch(getClientList(page, sizePerPage));
    }

    fetchClientList();

    return () => {
      dispatch( clearClientsList() );
    }
  }, []);

  const selectClient = (client) => {
    client.lineCreditCurrencyList = [... new Set(client.lineCreditCurrencyList)];
    props.selectedClient(client);
  }

  const searchFnc = (property, value) => {
    var actionFilters = [];
    if (value != "") { // Realizamos la busqueda por filtros
      actionFilters = [
        { property: `filter`, value: property },
        { property: `dataFilter`, value: value },
      ];
    }

    return handlerChange(page, sizePerPage, actionFilters);
  }

  const handlerChange = async (currentPage, currentSizePerPage, filters) => {
    return await dispatch( getClientList(currentPage, currentSizePerPage, filters) )
  }

  return <div className="find-institution-modal">
    <div className="header-clients">
      <div className="title">
        <img src={contactProvider} className="iconList" />
        <p className="p-list">{i18next.t('providers.manual.form.modal.title')}</p>
      </div>
      <div className="filter">
        <FilterComponent filter={filters} searchFnc={searchFnc} />
      </div>
    </div>
    <SimpleBar forceVisible="y" style={{ maxHeight: 300, width: 950 }}>
      <div className="modal-table">
        <TableClients
          data={clientes}
          page={page}
          getClientList={ handlerChange }
          totalSize={totalElements}
          sizePerPage={sizePerPage}
          action={selectClient}
          actionlbl={`${i18next.t('general.buttons.add')}`}
        />
      </div>
    </SimpleBar>
  </div>
};

export default FindInstitution;